import API_CONSTANT from 'constants/apiConstant';
import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerPanSaveApiCall, triggerValidatePanApiCallSuccess } from 'redux/actions';
import { TRIGGER_VALIDATE_PAN_API } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { ChangeHistory, CleverTapEvent, CleverTapEventNames, nativeHandler } from 'utils';

function* triggerValidatePanApiCall(actions) {
	const isOnboardingEnabled = store.getState().featureAccess?.onboardingEnabled;

	if (!isOnboardingEnabled) {
		nativeHandler.removeLoader();
		ChangeHistory('push', APP_ROUTES_CONSTANT.onboarding.upgrade);
	}

	const { data, callback } = actions;
	const sendData = {
		panNumber: data['panNumber'],
	};
	const CALL_SAVE_PAN = data?.['callSavePan'];
	const AUTOMATE_FLOW = data?.['autoMateFlow'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.VALIDATE_PAN,
		data: { ...sendData },
		method: 'POST',
		options: {
			dontRemoveLoader: true,
			restrictToast: true,
		},
		loaderDetails: {
			first_message: CALL_SAVE_PAN ? 'calculating your' : 'loading',
			start_index: 0,
			range: CALL_SAVE_PAN ? 11 : 7,
			second_message: CALL_SAVE_PAN ? 'credit limit' : 'please wait',
		},
	});
	if (api && api.data) {
		const apiData = api.data.data;
		callback && callback(api.data);
		yield put(triggerValidatePanApiCallSuccess(apiData));

		if (AUTOMATE_FLOW) {
			if (apiData?.isVerified) {
				CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.PAN_VERIFIED);
				if (apiData?.isNameVerified) {
					yield put(
						triggerPanSaveApiCall({
							panNumber: sendData['panNumber'],
							callHomeDetails: true,
							disableButton: data?.disableButton,
						}),
					);
				} else {
					nativeHandler.removeLoader();

					ChangeHistory('push', '/onboarding/bank-list');
				}
			} else {
				nativeHandler.removeLoader();

				ChangeHistory('push', '/onboarding/enter-pan');
			}
		}
	} else {
		data.disableButton && data.disableButton();
	}
}

export default function* triggerValidatePanApiCallSaga() {
	yield takeEvery(TRIGGER_VALIDATE_PAN_API, triggerValidatePanApiCall);
}
